// Moves inside a cadence, expressed on the grouped steps that `groupCadenceItemsIntoSteps` builds.
// A template never changes language, so it can only ever land in the slot of its own language.

function cloneSteps(steps) {
  return steps.map((step) => ({ ...step, itemsByLanguage: { ...step.itemsByLanguage } }));
}

function dropEmptySteps(steps) {
  // The API rejects an empty step, and an emptied one has no meaning on the page either.
  return steps.filter((step) => Object.values(step.itemsByLanguage).some(Boolean));
}

export function moveStep(steps, fromIndex, toIndex) {
  if (fromIndex === toIndex || !steps[fromIndex] || !steps[toIndex]) return steps;
  const next = [...steps];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
}

// Move one template to another step; an occupied slot swaps, an empty one just takes it.
export function moveTemplateToStep(steps, { fromIndex, toIndex, language }) {
  if (fromIndex === toIndex || !steps[fromIndex] || !steps[toIndex]) return steps;

  const moving = steps[fromIndex].itemsByLanguage[language];
  if (!moving) return steps;

  const next = cloneSteps(steps);
  const displaced = next[toIndex].itemsByLanguage[language] ?? null;

  next[toIndex].itemsByLanguage[language] = moving;
  if (displaced) {
    next[fromIndex].itemsByLanguage[language] = displaced;
  } else {
    delete next[fromIndex].itemsByLanguage[language];
  }

  return dropEmptySteps(next);
}

export function cadenceStepsToPayload(steps, languages) {
  return steps
    .map((step) =>
      languages
        .map((language) => step.itemsByLanguage[language])
        .filter(Boolean)
        .map((item) => item.template.id),
    )
    .filter((templateIds) => templateIds.length > 0);
}
